import React, { useState, useEffect } from 'react';
import Splash from './common/Splash';

function APIS({ setGlobalData, refreshPvtData }) {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const [isLoadingPublic, setIsLoadingPublic] = useState(true);
  const [isLoadingPrivate, setIsLoadingPrivate] = useState(isLoggedIn);
  const [error, setError] = useState(null);

  const [apiData, setApiData] = useState({
    sliders: { main: [], favourite: [], feature: [], referral: [], download: [] },
    socialLinks: [],
    general: {},
    paymentMethods: [],
    withdrawMethods: [],
    hasEWallet: false,
    promotions: { activePromotion: [], displayPromotion: [], allPromotions: [] },
    userData: null,
    transactions: [],
    turnovers: [],
    marketBlock: [],
  });

  // 🌍 Public APIs
  useEffect(() => {
    const fetchPublicData = async () => {
      setIsLoadingPublic(true);
      try {
        let headers = {};
        const token = localStorage.getItem('token');
        if (token) headers = { Authorization: `Bearer ${token}` };

        const [slidersData, socialData, generalData, paymentData, promotionsData] =
          await Promise.all([
            fetch(`${process.env.REACT_APP_API_URL}/api/sliders`, { headers }).then(res => res.json()),
            fetch(`${process.env.REACT_APP_API_URL}/api/sociallink`, { headers }).then(res => res.json()),
            fetch(`${process.env.REACT_APP_API_URL}/api/general`, { headers }).then(res => res.json()),
            fetch(`${process.env.REACT_APP_API_URL}/api/payment-methods`, { headers }).then(res => res.json()),
            fetch(`${process.env.REACT_APP_API_URL}/api/promotion`, { headers }).then(res => res.json()),
          ]);

        let pgs = [];
        let hasEWallet = false;
        if (paymentData?.type === 'ewallet') {
          pgs = paymentData?.pgs;
          hasEWallet = true;
        } else {
          pgs = paymentData;
        }

        setApiData(prev => ({
          ...prev,
          hasEWallet,
          sliders: {
            main: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Main'),
            favourite: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Favourite'),
            feature: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Features'),
            referral: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Referrals'),
            download: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Download'),
          },
          socialLinks: socialData[0] || {},
          general: generalData[0] || {},
          paymentMethods: pgs,
          promotions: {
            activePromotion: promotionsData.filter(p => p.status === 'active'),
            displayPromotion: promotionsData.filter(p => p.status === 'display'),
            allPromotions: promotionsData,
          },
        }));
      } catch (err) {
        console.error('Error fetching public data:', err);
        setError('Error fetching public API data');
      } finally {
        setIsLoadingPublic(false);
      }
    };
    fetchPublicData();
  }, []);

  // 🔐 Private APIs
  useEffect(() => {
    const token = localStorage.getItem('token');
    const remoteId = localStorage.getItem('remote_id');
    if (!isLoggedIn || !token || !remoteId) return;

    const fetchPrivateData = async () => {
      setIsLoadingPrivate(true);
      try {
        const [userData, transactions, turnovers, marketBlock] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/user/show?remote_id=${remoteId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }).then(res => res.json()),
          fetch(`${process.env.REACT_APP_API_URL}/api/transaction/show?remote_id=${remoteId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }).then(res => res.json()),
          fetch(`${process.env.REACT_APP_API_URL}/api/turnovers?remote_id=${remoteId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }).then(res => res.json()),
          fetch(`${process.env.REACT_APP_API_URL}/api/market/block`, {
            headers: { Authorization: `Bearer ${token}` },
          }).then(res => res.json()),
        ]);

        setApiData(prev => ({
          ...prev,
          userData,
          transactions,
          turnovers: turnovers.turnover || [],
          marketBlock: marketBlock || [],
        }));
      } catch (err) {
        console.error('Error fetching private data:', err);
        setError('Error fetching private API data');
      } finally {
        setIsLoadingPrivate(false);
      }
    };

    fetchPrivateData();
  }, [isLoggedIn, refreshPvtData]);

  // Sync to global state
  useEffect(() => {
    setGlobalData(apiData);
  }, [apiData, setGlobalData]);

  if (isLoadingPublic) return (
    <Splash/>
  );
  return null;
}

export default APIS;
